var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"Component",attrs:{"src":_vm.formattedSrc,"srcset":_vm.formattedSrcSet,"alt":_vm.alt,"loading":_vm.isNoLazy ? false : 'lazy'},on:{"error":_vm.onError}})}
var staticRenderFns = []

export { render, staticRenderFns }